<!-- font-awesome is used in this view for the 7 of the new fonts. Hence loaded directly from CDN instead of installing the package -->
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css">

<div class="stepper-container">
  <div class="stepper">
    @for (step of steps; track step) {
      <div
        class="step"
        [class.active]="step.isActive"
        >
        <div class="icon">
          <i [class]="step.icon"></i>
        </div>
        <span>{{ step.label }}</span>
      </div>
    }
  </div>
</div>